import React, { forwardRef } from "react";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import { observer } from "mobx-react";
import { IconButton, Grid } from "@material-ui/core";
import TriggerColumnRenderer from "./TriggerColumnRenderer";
import { MdClose } from "react-icons/md";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import styled, { css } from "styled-components";
import Paper from "@material-ui/core/Paper";

function TriggerColumnPopper({ store, hidden = false }, ref) {
  const [isClosed, setIsClosed] = React.useState(true);
  const anchorEl = store.actionButtons.anchorEl;
  const open = Boolean(anchorEl);
  const id = open ? "transitions-popper" : undefined;
  const [marginleft, setMarginLeft] = React.useState(65);
  const StyledPopper = styled(Popper)`
    z-index: 10;
    margin-left: ${marginleft}px;
  `;
  const StyledButton = styled(IconButton)`
    padding: ${props =>
      props.rowHeight === 36 ? "6px" : "12px"};
  `;

  const highlightRow = () => {
    let parentDOM = document.getElementById(store.gridId);
    if (
      parentDOM.querySelectorAll(
        "[row-Id='" + store?.actionButtons?.currentRowNode?.data?.row_id + "']"
      )?.[1] != undefined
    ) {
      parentDOM
        .querySelectorAll(
          "[row-Id='" + store.actionButtons.currentRowNode.data.row_id + "']"
        )?.[1]
        .classList.add("highlight-row");
    }
  };

  const unHighlightRow = () => {
    let parentDOM = document.getElementById(store.gridId);
    if (
      parentDOM.querySelectorAll(
        "[row-Id='" + store?.actionButtons?.currentRowNode?.data?.row_id + "']"
      )?.[1] != undefined
    ) {
      parentDOM
        .querySelectorAll(
          "[row-Id='" + store.actionButtons.currentRowNode.data.row_id + "']"
        )?.[1]
        .classList.remove("highlight-row");
    }
  };

  const closeTriggerColumnPopper = () => {
    store.isActionButtonsPopperOpen = false;
    setIsClosed(true);
    unHighlightRow();
  };

  const marginAdjustment = () => {
    const rowindex = store?.actionButtons?.currentRowNode?.data?.row_id;

    if (rowindex >= 1000 && rowindex < 10000) {
      setMarginLeft(70);
    }
    else if (rowindex >= 10000 && rowindex < 100000) {
      setMarginLeft(75);
    }
    else if (rowindex >= 100000 && rowindex < 1000000) {
      setMarginLeft(85);
    }
    else if (rowindex >= 1000000) {
      setMarginLeft(90);
    }
  };

  React.useEffect(() => {
    setIsClosed(true);
    unHighlightRow();
    marginAdjustment();
  }, [anchorEl]);

  if (
    (store.isSubsheet && store.userEvents.length === 0) ||
    !store.actionButtons.currentRowNode ||
    !store.actionButtons.currentRowNode.data?.row_id ||
    store.actionButtons.currentRowNode.data.row_id === "+"
  ) {
    return null;
  }

  if (
    store.props?.view?.type == "table" &&
    store.props?.view?.list_id &&
    store.props?.view?.options?.main_list_id &&
    store.props?.view?.list_id != store.props?.view?.options?.main_list_id
  ) {
    return null;
  }

  return (
    <StyledPopper
      id={id}
      open={open}
      anchorEl={anchorEl}
      transition
      placement="left"
      disablePortal={true}
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: "scrollParent",
        },
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps}>
          <StyledGrid
            container
            ref={ref}
            justify="center"
            alignItems="center"
            isClosed={isClosed}
          >
            {!isClosed ? (
              <>
                <Paper elevation={1}>
                  <TriggerColumnRenderer
                    store={store}
                    data={store.actionButtons.currentRowNode.data}
                    actionButtonsCount={
                      store.getActiveRowActionButtons(
                        store.actionButtons.currentRowNode.data
                      ).length
                    }
                    closeTriggerColumnPopper={closeTriggerColumnPopper}
                  />
                </Paper>
                <IconButton
                  onClick={() => {
                    store.isActionButtonsPopperOpen = false;
                    setIsClosed(true);
                    unHighlightRow();
                  }}
                >
                  <MdClose />
                </IconButton>
              </>
            ) : (
              <StyledButton
                onClick={() => {
                  store.isActionButtonsPopperOpen = true;
                  setIsClosed(false);
                  highlightRow();
                }}
                color="primary"
              >
                <KeyboardArrowDownIcon />
              </StyledButton>
            )}
          </StyledGrid>
        </Fade>
      )}
    </StyledPopper>
  );
}

const StyledGrid = styled(Grid)`
  ${(props) =>
    !props.isClosed &&
    css`
      background: rgba(250, 250, 250, 0.85);
      color: black;
    `}
`;

export default observer(forwardRef(TriggerColumnPopper));
